<template>
<div>
    <router-view></router-view>
</div>
</template>

<script>
import Vue from 'vue';
import $ from 'jquery'
Vue.prototype.$ = $
import {
    mapState,
    mapMutations
} from "vuex";

import {
    BootstrapVue,
    IconsPlugin
} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(BootstrapVue)
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);
import loader from "./containers/loader";

/* import turn from './lib/turn.js'
Vue.prototype.turn = turn */
export default {
    name: 'app',
    components: {
        loader,
    },
    data() {
        return {
            estado: '/'
        }
    },
}
</script>
 <!--style src="./assets/css/bootstrap.min.css"></style-->

<style src="./assets/css/basic.css"></style>
<style lang="scss" src="./assets/issue.scss"></style>

 
